import { Item } from './helpers/types'

export function dataLayerSelectItem(item: Item) {
  if (!item) {
    return
  }

  if (window['dataLayer']) {
    window['dataLayer'].push({ ecommerce: null })

    window['dataLayer'].push({
      event: 'select_item',
      ecommerce: {
        items: [item],
      },
    })
  }
}
